import { useTranslate } from "src/i18n";

export const useWhyUsBlockTranslate = () => {
  const { t } = useTranslate();

  const title = t("outsourcing.why_us_block.title", "Почему именно мы?");

  const description = t(
    "outsourcing.why_us_block.description",
    "Стоит ли выбирать нас, как партнеров в создание интернет-магазина",
  );

  const whyUsData = [
    {
      number: "01",
      title: t(
        "outsourcing.why_us_block.why_us_data.0.title",
        "Индивидуальный подход",
      ),
      description: t(
        "outsourcing.why_us_block.why_us_data.0.description",
        "Мы не предлагаем шаблонные решения. Каждый магазин, созданный с нами, уникален и разработан с учетом специфики вашего бизнеса, целевой аудитории и рыночных условий.",
      ),
    },
    {
      number: "02",
      title: t(
        "outsourcing.why_us_block.why_us_data.1.title",
        "Экономия времени и ресурсов",
      ),
      description: t(
        "outsourcing.why_us_block.why_us_data.1.description",
        "Наша команда берет на себя все технические аспекты разработки и настройки магазина, позволяя вам сосредоточиться на развитии бизнеса. Мы используем проверенные технологии и готовые решения, что ускоряет процесс запуска.",
      ),
    },
    {
      number: "03",
      title: t(
        "outsourcing.why_us_block.why_us_data.2.title",
        "Поддержка на каждом этапе",
      ),
      description: t(
        "outsourcing.why_us_block.why_us_data.2.description",
        "От идеи до запуска и дальнейшего развития — мы сопровождаем вас на всех этапах. Наши специалисты всегда готовы помочь с настройкой, оптимизацией и масштабированием вашего магазина.",
      ),
    },
    {
      number: "04",
      title: t(
        "outsourcing.why_us_block.why_us_data.3.title",
        "Результаты, которые говорят сами за себя",
      ),
      description: t(
        "outsourcing.why_us_block.why_us_data.3.description",
        "Наши клиенты отмечают увеличение конверсии, улучшение пользовательского опыта и рост продаж уже в первые месяцы после запуска магазина.",
      ),
    },
    {
      number: "05",
      title: t(
        "outsourcing.why_us_block.why_us_data.4.title",
        "Готовы начать?",
      ),
      description: t(
        "outsourcing.why_us_block.why_us_data.4.description",
        "Оставьте заявку, и мы свяжемся с вами для обсуждения вашего проекта. Создайте магазин, который будет выделяться на фоне конкурентов и приносить стабильный доход!",
      ),
    },
  ];

  return { title, description, whyUsData };
};
